import {
  DEFAULT_PAGE_PADDING,
  normalizePagePadding,
  type PagePadding,
} from "@/lib/cms-puck/blocks/page-padding";
import type { BlockSpacingBox, SpacingUnit } from "@/lib/cms-puck/block-style";
import {
  SpacingBoxEditor,
  SPACING_UNITS,
} from "@/components/cms-puck/fields/style/SpacingBoxEditor";
import { StyleSection } from "@/components/cms-puck/fields/style/StyleSection";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useCmsNew } from "@/lib/cms/cms-new-i18n";

/**
 * Champ padding GLOBAL de la page (`root.props.padding`).
 * Même UX que le padding des blocs (4 côtés + unité).
 */
export function PagePaddingField({
  value,
  onChange,
}: {
  value: PagePadding | undefined;
  onChange: (value: PagePadding) => void;
}) {
  const cmsNew = useCmsNew();
  const padding = normalizePagePadding(value ?? DEFAULT_PAGE_PADDING);

  const setBox = (box: BlockSpacingBox) =>
    onChange({ ...padding, ...box });

  return (
    <div className="space-y-4 p-1">
      <SpacingBoxEditor
        title={cmsNew(
          "cms.new.page.settings.paddingTitle",
          "Marge intérieure de la page",
        )}
        description={cmsNew(
          "cms.new.page.settings.paddingDescription",
          "Appliquée à toute la page (tous les blocs). Indépendant du padding de chaque bloc.",
        )}
        box={{
          top: padding.top,
          right: padding.right,
          bottom: padding.bottom,
          left: padding.left,
        }}
        onChange={setBox}
      />
      <StyleSection
        title={cmsNew("cms.new.auto.title.unite", "Unité")}
        description={cmsNew(
          "cms.new.page.settings.paddingUnitDescription",
          "Appliquée aux quatre côtés.",
        )}
      >
        <Select
          value={padding.unit}
          onValueChange={(unit) =>
            onChange({ ...padding, unit: unit as SpacingUnit })
          }
        >
          <SelectTrigger className="h-9 w-28 bg-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {SPACING_UNITS.map((u) => (
              <SelectItem key={u} value={u}>
                {u}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </StyleSection>
    </div>
  );
}
